import { t as p } from "./morphNodes-DmouWQ1Y.js";
var w = () => ({
  productSoldOut: !1,
  hasRequired: !0,
  controller: new AbortController(),
  checkRequired(e) {
    const t = new FormData(e);
    this.hasRequired = e.elements.toArray().filter((i) => i instanceof HTMLInputElement || i instanceof HTMLSelectElement || i instanceof HTMLTextAreaElement).filter((i) => i.required && i.name?.endsWith("[id]")).map((i) => t.get(i.name)).every((i) => i && i !== "null");
  },
  init() {
    const e = this.$el.querySelector("form[action='/cart/add']");
    e?.addEventListener("change", () => {
      this.checkRequired(e);
    }, { signal: this.controller.signal }), e && this.checkRequired(e);
  },
  destroy() {
    this.controller.abort();
  },
  async changeVariant(e) {
    console.log("Replacing page with:", e);
    const t = new URL(e, window.location.origin);
    window.history.replaceState({}, "", t);
    const i = await (await fetch(t)).text();
    if (!i) {
      console.error("Failed to fetch the new variant page:", e);
      return;
    }
    const r = this.$el.closest('section[id^="shopify-section"]');
    if (!r) {
      console.warn("No current section found for variant change");
      return;
    }
    p(i, `#${r.id}`);
  }
}), A = () => ({ async handleSubmit(e) {
  if (window.NewThink?.ACCESS_GATE_CAN_BUY === !1) {
    window.location.href = window.NewThink.ACCESS_GATE_LOGIN_URL ?? "/account/login";
    return;
  }
  if (!e.reportValidity()) return;
  const t = new FormData(e);
  if (Array.from(t.entries()).filter(c(f)).filter(([n, o]) => o === "").forEach(([n]) => t.delete(n)), t.has("items[0][properties][_bundle_parent]")) {
    const n = Array.from(t.entries()).filter(c("[id]")).map(([s, a]) => a).map(String), o = await g(n.filter((s) => s !== "" && s !== "null")), m = parseInt(t.get("items[0][quantity]")) || 1;
    n.forEach((s, a) => {
      s === "" || s === "null" ? Array.from(t.keys()).filter(u(`items[${a}]`)).forEach(t.delete.bind(t)) : (t.append(`items[${a}][properties][_bundle_id]`, o), t.has(`items[${a}][quantity]`) || t.append(`items[${a}][quantity]`, m.toString()));
    });
  }
  const i = Array.from(e.elements).find((n) => n.id.startsWith("product-notes-"));
  Array.from(t.entries()).filter(c("[quantity]")).filter(([n, o]) => o === "0").map(d("[quantity]")).forEach((n) => Array.from(t.keys()).filter(u(n)).forEach(t.delete.bind(t)));
  const r = t.get("selling_plan"), l = Array.from(t.keys()).filter((n) => /^items\[\d+\]\[id\]$/.test(n)).map((n) => n.slice(0, -4));
  r !== null && l.length > 0 && (t.delete("selling_plan"), r !== "" && l.forEach((n) => t.set(`${n}[selling_plan]`, String(r)))), i?.value && Array.from(t.entries()).filter(c("[id]")).map(d("[id]")).map(y(i.name.match(/\[properties\]\[.+\]/)?.[0])).forEach((n) => {
    t.append(n, i.value);
  });
  const h = await fetch(e.action + ".js", {
    method: e.method,
    body: t
  });
  if (!h.ok) {
    console.error("Failed to submit form:", h.statusText);
    return;
  }
  this.$store.cart.isOpen ? this.$store.cart.load() : this.$store.cart.open(), this.changeVariant?.(window.location.href);
} }), E = () => ({
  controller: new AbortController(),
  hasQuantity: !1,
  quantity: 1,
  unitPrice: 0,
  priceBreaks: [],
  planPrices: {},
  sellingPlanId: "",
  priceDelimiter: "",
  isBundle: !1,
  bundleItems: [],
  observer: null,
  init() {
    const e = this.$el.form;
    console.assert(e, "LockedATC must be initialized on a button in a form");
    const t = this.$dataset;
    if (this.unitPrice = Number(t.unitPrice) || 0, this.priceDelimiter = t.priceDelimiter ?? "", this.isBundle = t.isBundle === "true", this.priceBreaks = JSON.parse(t.priceBreaks || "[]").sort(([i], [r]) => i - r), this.planPrices = Object.fromEntries(JSON.parse(t.planPrices || "[]")), e?.addEventListener("change", () => {
      this.$nextTick(() => this.checkQuantity(e));
    }, { signal: this.controller.signal }), e) {
      this.$nextTick(() => this.checkQuantity(e));
      const i = () => requestAnimationFrame(() => this.checkQuantity(e));
      document.addEventListener("click", i, { signal: this.controller.signal }), document.addEventListener("input", i, { signal: this.controller.signal }), this.observer = new MutationObserver(i), this.observer.observe(e, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["value"]
      });
    }
    this.isBundle && (document.addEventListener("bundle-option-change", (i) => {
      const { index: r, price: l } = i.detail ?? {};
      this.bundleItems[Number(r) || 0] = Number(l) || 0;
    }, { signal: this.controller.signal }), this.$nextTick(() => this.$dispatch("request-option-prices")));
  },
  checkQuantity(e) {
    const t = new FormData(e);
    this.quantity = Number(t.get("items[0][quantity]")) || 1, this.sellingPlanId = String(t.get("items[0][selling_plan]") ?? t.get("selling_plan") ?? "");
    const i = Array.from(t.entries()).filter(([r]) => r.endsWith("[quantity]"));
    if (i.length === 0) {
      this.hasQuantity = !0;
      return;
    }
    this.hasQuantity = i.map(([, r]) => Number(r)).some((r) => r > 0);
  },
  get atcUnitPrice() {
    if (this.isBundle) return this.bundleItems.reduce((t, i) => t + (i || 0), 0);
    const e = this.planPrices[this.sellingPlanId];
    return e || this.priceBreaks.reduce((t, [i, r]) => this.quantity >= i ? r : t, this.unitPrice);
  },
  atcPriceText(e = !0) {
    if (this.isBundle && (!e || this.bundleItems.length === 0)) return "";
    const t = this.$formatMoney(this.atcUnitPrice * Math.max(this.quantity, 1) / 100);
    return t ? ` ${this.priceDelimiter} ${t}` : "";
  },
  destroy() {
    this.controller.abort(), this.observer?.disconnect();
  }
}), f = [
  "[Send on]",
  "[Message]",
  "[selling_plan]"
], c = (e) => ([t]) => Array.isArray(e) ? e.some((i) => t.endsWith(i)) : t.endsWith(e), d = (e) => ([t]) => Array.isArray(e) ? e.reduce((i, r) => i.endsWith(r) ? i.slice(0, -r.length) : i, t) : t.endsWith(e) ? t.slice(0, -e.length) : t, y = (e = "") => (t) => t + e, u = (e) => (t) => t.startsWith(e), g = async (e) => {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e.toSorted().join("-")));
  return Array.from(new Uint8Array(t)).map((i) => i.toString(16).padStart(2, "0")).join("");
};
Array.prototype.toSorted ??= function(e) {
  return [...this].sort(e);
};
HTMLFormControlsCollection.prototype.toArray ??= function() {
  return Array.from(this);
};
export {
  E as LockedATC,
  A as ProductForm,
  w as ProductMain,
  w as default
};
